import React, { CSSProperties } from "react";
import AggregationFunctions from "./AggregationFunctions";
import PinnedShadow from "./components/PinnedShadow";
import { Table } from "@tanstack/react-table";

interface TableAggregationProps {
  headers: any;
  project: any;
  table: Table<any>;
  getPinnedStyle: (column: any, isHeader: boolean) => CSSProperties;
  isScrolled: boolean;
}

const TableAggregation: React.FC<TableAggregationProps> = ({
  headers,
  project,
  table,
  getPinnedStyle,
  isScrolled,
}) => {
  const getField = (fieldId: string, formType: string) => {
    return project
      .get("fields")
      .find((f: any) => f.get("id") === fieldId && f.get("formType") === formType);
  };

  return (
    <tr className="border-b border-b-gray-300">
      {headers.map((head: any) => {
        const selector = head.get("selector");
        const tanstackColumn = table.getColumn(selector);
        const isPinned = tanstackColumn ? !!tanstackColumn.getIsPinned() : false;
        const pinnedStyle = tanstackColumn ? getPinnedStyle(tanstackColumn, false) : {};
        const columnWidth = tanstackColumn ? tanstackColumn.getSize() : undefined;

        // Pinned footer cells need higher z-index to stay above non-pinned cells when scrolling
        const cellZIndex = isPinned ? 20 : 10;

        const field = getField(selector, head.get("formType"));
        // Render empty cell when field is not found to keep column alignment
        if (!field) {
          return (
            <td
              key={`aggregation_${selector}`}
              className={`sticky bottom-0 border-t border-t-gray-200 h-10 bg-white`}
              style={{
                width: columnWidth,
                minWidth: columnWidth,
                ...pinnedStyle,
                zIndex: cellZIndex,
              }}
            >
              {isPinned && <PinnedShadow isScrolled={isScrolled} />}
            </td>
          );
        }
        return (
          <td
            key={`aggregation_${selector}`}
            className={`sticky bottom-0 text-right text-sm border-t border-t-gray-200 border-r border-r-gray-200 h-10 bg-white p-0 overflow-hidden`}
            style={{
              width: columnWidth,
              minWidth: columnWidth,
              ...pinnedStyle,
              zIndex: cellZIndex,
            }}
          >
            {isPinned && <PinnedShadow isScrolled={isScrolled} />}
            <AggregationFunctions
              headers={headers}
              header={head}
              projectId={project.get("id")}
              field={field}
            />
          </td>
        );
      })}
    </tr>
  );
};

export default TableAggregation;
